module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Page not found.","message":"This is a 404 error. We\u0027re sorry.","backlink":"Back to the {0}","homepage":"Home page"},"de":{"title":"Seite nicht gefunden.","message":"Dies ist ein 404-Fehler. Das hätte nicht passieren sollen.","backlink":"Zurück zur {0}","homepage":"Startseite"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/NotFound.vue
// module id = GkQ8
// module chunks = 0